




































































































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import { format, date } from 'quasar'
import ModalDialog from 'components/modals/Dialog.vue'

@Component({
  components: {
    ModalDialog
  }
})
export default class DateTime extends Vue {
  pad = format.pad
  datetime = new Date()
  selectHours = false
  selectMinutes = false

  @Prop()
  readonly value!: Date

  @Prop()
  readonly title!: string

  @Prop()
  readonly message!: string

  get date () {
    return date.formatDate(this.datetime.getTime(), 'YYYY/MM/DD')
  }

  get selectHoursSlide () {
    return Math.floor(this.datetime.getHours() / 12)
  }

  get selectMinutesSlide () {
    return Math.floor(this.datetime.getMinutes() / 10)
  }

  @Ref()
  readonly dialog!: ModalDialog

  @Watch('value', { immediate: true })
  update () {
    this.datetime = this.value || new Date()
    this.datetime.setSeconds(0, 0)
  }

  ok (action: string) {
    if (action === 'left') {
      this.hide()
    } else if (action === 'middle') {
      this.clear()
    } else {
      this.select()
    }
  }

  show () {
    this.selectHours = this.selectMinutes = false
    this.dialog.show()
  }

  hide () {
    this.dialog.hide()
  }

  clear () {
    this.dialog.hide()
    this.$emit('input', null)
  }

  select () {
    this.dialog.hide()
    this.$emit('input', this.datetime)
  }

  setDate (date: string) {
    const datetime = new Date(date)
    datetime.setHours(this.datetime.getHours())
    datetime.setMinutes(this.datetime.getMinutes())
    this.datetime = datetime
  }

  setHours (hours: number) {
    this.datetime = new Date(this.datetime.setHours(hours))
    this.selectHours = false
  }

  setMinutes (minutes: number) {
    this.datetime = new Date(this.datetime.setMinutes(minutes))
    this.selectMinutes = false
  }

  addHours (hours: number) {
    this.datetime = new Date(this.datetime.setHours((24 + this.datetime.getHours() + hours) % 24))
  }

  addMinutes (minutes: number) {
    this.datetime = new Date(this.datetime.setMinutes((60 + this.datetime.getMinutes() + minutes) % 60))
  }
}
